import { useQuery } from '@tanstack/react-query';
import { HTTPError } from 'ky';
import { useSession } from 'next-auth/react';
import { ShopTypes } from '~/lib/data-contract';
import useUserProfile from '~/services/shop/hooks/mit-fog/useUserProfile';
import { getUsersList } from '../../operations/mit-fog';

export default function useUsersList() {
    const { data } = useSession();
    const { data: profile } = useUserProfile();
    const customerId = profile?.user?.currentCustomerId ?? null;
    const token = data?.accessToken ?? null;

    return useQuery<ShopTypes.CustomerUsersResponse, HTTPError>(
        ['userList', { customerId, token }],
        ({ signal }) =>
            getUsersList({
                customerId,
                token,
                signal,
            }),
        {
            enabled: Boolean(data?.accessToken),
        },
    );
}
